export default __webpack_public_path__ + "static/media/Approver_icon.05be6f78.svg";